// extracted by mini-css-extract-plugin
export default {"button":"CallButton_button__X9Rss","subtitle":"CallButton_subtitle__9GY4L"};